import React from 'react';
import { observer } from 'mobx-react-lite';
import { convertAmount, getAmountWithCurrency, useTranslation } from '@pascal/pascal-core';

import { doBetStore } from '../../../store';
import { globalTranslationKeys } from '../../../enums';

const WinPopUp = observer(() => {
  const t = useTranslation();
  const { winAmount, marketType } = doBetStore;

  return winAmount ? (
    <div className={`monti-banner ${!marketType ? 'blue' : 'green'}`}>
      <p className='monti-banner-heading'>{t(globalTranslationKeys.YouWin)}</p>
      <p className='monti-banner-amount'>
        {getAmountWithCurrency({
          amount: convertAmount(+winAmount.toFixed(2)),
        })}
      </p>
    </div>
  ) : (
    <></>
  );
});

export default WinPopUp;
